
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var SearchInput = require('../../components/inputs/search');
var Form = require('../../components/forms/generic');
var connect = require('../../components/connect');
var styles = require('./search-input.css');
var Router = require('@npm/spiferack/shared/router');

var _require = require('../../../lib/apps/audit-logs/constants'),
    FORM_ID = _require.FORM_ID;

var AuditSearchInput = function (_React$PureComponent) {
  _inherits(AuditSearchInput, _React$PureComponent);

  function AuditSearchInput() {
    _classCallCheck(this, AuditSearchInput);

    return _possibleConstructorReturn(this, (AuditSearchInput.__proto__ || Object.getPrototypeOf(AuditSearchInput)).apply(this, arguments));
  }

  _createClass(AuditSearchInput, [{
    key: 'search',
    value: function search(ev) {
      ev.preventDefault();

      var query = ev.target.q.value;
      var data = new Map();
      data.set('q', query);

      Router.get().submit({
        method: 'GET',
        action: this.props.auditLogsURL,
        data: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formData = this.props.formData;


      return React.createElement(
        Form,
        {
          className: styles.searchForm,
          formId: FORM_ID,
          formData: formData,
          showButton: false,
          action: '',
          onSubmit: function onSubmit(ev) {
            return _this2.search(ev);
          }
        },
        React.createElement(SearchInput, {
          name: 'q',
          maxLength: 500,
          containerClass: styles.searchContainer,
          inputClass: styles.searchInput,
          formId: FORM_ID,
          formData: formData,
          placeholder: 'Search audit logs...'
        })
      );
    }
  }]);

  return AuditSearchInput;
}(React.PureComponent);

module.exports = connect()(AuditSearchInput);
  let __hot__
  
  __registry__.register('audit-logs/audit-search-input', module.exports, __hot__)
  